import { FormattedMessage } from 'react-intl';
import TabularPage from '../components/tabs/TabularPage';
import { RESOURCE_PLANNING_ROUTES } from 'constants/routes';

export const resourcePlanningTabs = [
    {
        name: <FormattedMessage id="resource_planning_econ_assumption" />,
        relativePath: RESOURCE_PLANNING_ROUTES.ECONOMIC_ASSUMPTION,
    },
    {
        name: <FormattedMessage id="resource_planning_objective_function" />,
        relativePath: RESOURCE_PLANNING_ROUTES.OBJECTIVE_FUNCTION,
    },
    {
        name: <FormattedMessage id="resource_planning_planning_constraints" />,
        relativePath: RESOURCE_PLANNING_ROUTES.PLANNING_CONSTRAINTS,
    },
    {
        name: <FormattedMessage id="resource_planning_project_details" />,
        relativePath: RESOURCE_PLANNING_ROUTES.PROJECT_DETAILS,
    },
];

const ResourcePlanningPage = () => {
    return <TabularPage isAutoForm routes={resourcePlanningTabs} />;
};

export default ResourcePlanningPage;
